export class ApiRequest {
    title: string;
    siteUrl: string;
}
